/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type GetServiceAccountAuthServiceAccountsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class GetServiceAccountAuthServiceAccountsResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: GetServiceAccountAuthServiceAccountsResponse429ResponseBodyData;

  constructor(
    err: GetServiceAccountAuthServiceAccountsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetServiceAccountAuthServiceAccountsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type GetServiceAccountAuthServiceAccountsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class GetServiceAccountAuthServiceAccountsResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: GetServiceAccountAuthServiceAccountsResponse409ResponseBodyData;

  constructor(
    err: GetServiceAccountAuthServiceAccountsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetServiceAccountAuthServiceAccountsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type GetServiceAccountAuthServiceAccountsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class GetServiceAccountAuthServiceAccountsResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: GetServiceAccountAuthServiceAccountsResponse404ResponseBodyData;

  constructor(
    err: GetServiceAccountAuthServiceAccountsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetServiceAccountAuthServiceAccountsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type GetServiceAccountAuthServiceAccountsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class GetServiceAccountAuthServiceAccountsResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: GetServiceAccountAuthServiceAccountsResponseResponseBodyData;

  constructor(
    err: GetServiceAccountAuthServiceAccountsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetServiceAccountAuthServiceAccountsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type GetServiceAccountAuthServiceAccountsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class GetServiceAccountAuthServiceAccountsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetServiceAccountAuthServiceAccountsResponseBodyData;

  constructor(
    err: GetServiceAccountAuthServiceAccountsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetServiceAccountAuthServiceAccountsResponseBody";
  }
}

/**
 * Bad request
 */
export type GetServiceAccountResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class GetServiceAccountResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetServiceAccountResponseBodyData;

  constructor(
    err: GetServiceAccountResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetServiceAccountResponseBody";
  }
}

/** @internal */
export const GetServiceAccountAuthServiceAccountsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    GetServiceAccountAuthServiceAccountsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetServiceAccountAuthServiceAccountsResponse429ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type GetServiceAccountAuthServiceAccountsResponse429ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const GetServiceAccountAuthServiceAccountsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    GetServiceAccountAuthServiceAccountsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    GetServiceAccountAuthServiceAccountsResponse429ResponseBody
  > = z.instanceof(GetServiceAccountAuthServiceAccountsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetServiceAccountAuthServiceAccountsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    GetServiceAccountAuthServiceAccountsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetServiceAccountAuthServiceAccountsResponse409ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type GetServiceAccountAuthServiceAccountsResponse409ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const GetServiceAccountAuthServiceAccountsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    GetServiceAccountAuthServiceAccountsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    GetServiceAccountAuthServiceAccountsResponse409ResponseBody
  > = z.instanceof(GetServiceAccountAuthServiceAccountsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetServiceAccountAuthServiceAccountsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    GetServiceAccountAuthServiceAccountsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetServiceAccountAuthServiceAccountsResponse404ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type GetServiceAccountAuthServiceAccountsResponse404ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const GetServiceAccountAuthServiceAccountsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    GetServiceAccountAuthServiceAccountsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    GetServiceAccountAuthServiceAccountsResponse404ResponseBody
  > = z.instanceof(GetServiceAccountAuthServiceAccountsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetServiceAccountAuthServiceAccountsResponseResponseBody$inboundSchema:
  z.ZodType<
    GetServiceAccountAuthServiceAccountsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetServiceAccountAuthServiceAccountsResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetServiceAccountAuthServiceAccountsResponseResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const GetServiceAccountAuthServiceAccountsResponseResponseBody$outboundSchema:
  z.ZodType<
    GetServiceAccountAuthServiceAccountsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    GetServiceAccountAuthServiceAccountsResponseResponseBody
  > = z.instanceof(GetServiceAccountAuthServiceAccountsResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetServiceAccountAuthServiceAccountsResponseBody$inboundSchema:
  z.ZodType<
    GetServiceAccountAuthServiceAccountsResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetServiceAccountAuthServiceAccountsResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetServiceAccountAuthServiceAccountsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetServiceAccountAuthServiceAccountsResponseBody$outboundSchema:
  z.ZodType<
    GetServiceAccountAuthServiceAccountsResponseBody$Outbound,
    z.ZodTypeDef,
    GetServiceAccountAuthServiceAccountsResponseBody
  > = z.instanceof(GetServiceAccountAuthServiceAccountsResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetServiceAccountResponseBody$inboundSchema: z.ZodType<
  GetServiceAccountResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetServiceAccountResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetServiceAccountResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetServiceAccountResponseBody$outboundSchema: z.ZodType<
  GetServiceAccountResponseBody$Outbound,
  z.ZodTypeDef,
  GetServiceAccountResponseBody
> = z.instanceof(GetServiceAccountResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
